import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="border-t border-white/[0.08] bg-[#0A0A0C]" data-testid="storefront-footer">
    <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-8 md:grid-cols-4">
      <div>
        <div className="flex items-center gap-2">
          <img src="/logo192.png" alt="TrendDrop logo" className="h-8 w-8 rounded-lg" />
          <span className="font-heading text-lg font-bold text-white">
            Trend<span className="text-amber-400">Drop</span>
          </span>
        </div>
        <p className="mt-4 text-sm text-slate-400">
          Trending products sourced at the manufacturer level and shipped straight to your door. No middlemen.
        </p>
      </div>
      <div>
        <p className="eyebrow mb-4">Shop</p>
        <div className="flex flex-col gap-2 text-sm text-slate-400">
          <Link className="hover:text-amber-300" to="/shop">All products</Link>
          <Link className="hover:text-amber-300" to="/shop?badge=trending">Trending now</Link>
          <Link className="hover:text-amber-300" to="/shop?badge=bestseller">Best sellers</Link>
        </div>
      </div>
      <div>
        <p className="eyebrow mb-4">Support</p>
        <div className="flex flex-col gap-2 text-sm text-slate-400">
          <Link className="hover:text-amber-300" to="/track">Track your order</Link>
          <Link className="hover:text-amber-300" to="/returns">Returns & refunds</Link>
          <Link className="hover:text-amber-300" to="/contact" data-testid="footer-contact-link">Contact us</Link>
          <a className="hover:text-amber-300" href="mailto:support@trenddropmedia.com" data-testid="footer-email-link">support@trenddropmedia.com</a>
          <a className="hover:text-amber-300" href="mailto:billing@trenddropmedia.com" data-testid="footer-billing-link">billing@trenddropmedia.com</a>
          <Link className="hover:text-amber-300" to="/privacy-policy" data-testid="footer-privacy-link">Privacy Policy</Link>
          <Link className="hover:text-amber-300" to="/terms-of-service" data-testid="footer-terms-link">Terms of Service</Link>
          <span>30-day return window</span>
        </div>
      </div>
      <div>
        <p className="eyebrow mb-4">Fulfilment</p>
        <p className="text-sm text-slate-400">
          Orders are placed directly with verified AliExpress & Alibaba suppliers who ship straight to you.
        </p>
      </div>
    </div>
    <div className="border-t border-white/[0.06] py-5 text-center text-xs text-slate-600">
      © 2026 TrendDrop. All rights reserved.
    </div>
  </footer>
);
